module.exports = __webpack_public_path__ + "img/egg-sticky.ea0c900a.svg";